module.exports = __webpack_public_path__ + "img/자신감.0fceb498.svg";